import logo from '../../images/icon.png';

const redirectUrl = window.location.origin;
export default {
  auth: {
    redirectUrl: `${redirectUrl}/callback`,
    responseType: 'token id_token',
    scope: 'openid profile email',
  },
  theme: {
    logo,
    primaryColor: '#00acc1',
  },
  languageDictionary: { title: 'Pingum' },
  state: 'dashboard',
  rememberLastLogin: false, // don't set this to true, there is a bug
  // if remember is on do this to replicate bug:
  /*
    Open browser in incognito and load a direct tenant link. ex: http://severson.localhost:3000/settings/notifications
    Once logged in, log out using the logout button in the nav
    Once logged out, go directly to the same tenant link again
    Click in the remembered user and a loop of calls on the login page kills the browser.
    We probably don't want the remembered user any for security since you are not
    prompted for a password when you click on the remembered user.
  */
  AUTH0_CLIENT_ID: env.REACT_APP_AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: env.REACT_APP_AUTH0_DOMAIN,
};
